import path from "node:path";
import { CookieMap, downloadImage, getFilenameFromUrl, Locator, Response, success, TaskState } from "@iflyrpa/share";
// import { Xhshow } from "../../utils/xhsXsEncrypt";
import type { PublishAction } from "./index";
// const GenXSCommon = require("../../utils/XhsXsCommonEnc.js") as (a1cookie: string, x_t: string|number, x_s:string) => string;

// 小红书参数加密器
// const xsEncrypt = new Xhshow();

export const rpaAction: PublishAction = async (task, params) => {
    const updateTaskState = task.taskStageStore?.update?.bind(task.taskStageStore, task.taskId || "");

    const commonCookies = {
        path: "/",
        sameSite: "lax",
        secure: false,
        domain: ".xiaohongshu.com",
        url: "https://creator.xiaohongshu.com",
        httpOnly: true,
    };

    const page = await task.createPage({
        show: task.debug,
        url: params.url || "https://creator.xiaohongshu.com/publish/publish",
        cookies: params.cookies?.map((it) => ({ ...it, ...commonCookies })),
    });

    await updateTaskState?.({
        state: TaskState.ACTION,
        connectAddress: task.steelConnector?.getProxyUrl(task.sessionId || "", "v1/sessions/debug"),
        sessionId: task.sessionId,
    });
    const tmpCachePath = task.getTmpPath();

    // const interceptUrls = [
    // 	'/api/media/v1/upload/creator/permit',
    // 	'/api/galaxy/v2/creator/activity_center/list',
    // 	'/web_api/sns/v5/creator/topic/template/list',
    // 	'/web_api/sns/v5/creator/file/encryption',
    // 	'/web_api/sns/capa/postgw/topic/batch_customized',
    // 	'/web_api/sns/v2/note'
    // ];

    // await page.route('**', async (route, request) => {
    // 	const url = request.url();
    // 	if (interceptUrls.some(pattern => url.includes(pattern))) {
    // 		const urlObj = new URL(url);
    // 		const fetchCoverUrl = urlObj.pathname + urlObj.search;
    //         const fetchCoverParams = Object.fromEntries(new URLSearchParams(urlObj.search));
    // 		const xt = Date.now().toString();
    //
    // 		const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    // 		if (!a1Cookie) {
    // 			await route.fulfill({
    // 				status: 200,
    // 				contentType: 'application/json',
    // 				body: JSON.stringify({ code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: "" })
    // 			});
    // 			return;
    // 		}
    //
    // 		const isNoteRequest = urlObj.pathname.includes(interceptUrls[5]);
    //
    // 		const xs = await (isNoteRequest
    // 			? (async () => {
    // 				const publishData = JSON.parse(request.postData() || "")
    // 				return xsEncrypt.signXsPost(interceptUrls[5], a1Cookie,"xhs-pc-web" ,publishData);
    // 			  })(): xsEncrypt.signXsGet(urlObj.pathname, a1Cookie, "xhs-pc-web" , fetchCoverParams))
    //
    //         const xscommon = GenXSCommon(a1Cookie, xt, xs)
    //
    // 		const newHeaders = {
    // 			...request.headers(),
    // 			'x-s': xs,
    //             'x-s-common':xscommon
    // 		};
    //
    // 		await route.continue({ headers: newHeaders });
    // 	}else {
    // 		await route.continue();
    // 	}
    // });

    // 通用的选择地点
    const selectAddress = async (selector: Locator, address: string) => {
        const instance = typeof selector === "string" ? page.locator(selector) : selector;
        await instance.click();
        await instance.locator("input").fill(address);
        const poperInstance = page.locator('.d-popover:not([style*="display: none"]) .d-options .d-grid-item');
        await poperInstance.first().waitFor();
        await poperInstance.first().click();
    };

    // 通用的选择日期
    const selectDate = async (selector: string | Locator, date: string) => {
        const instance = typeof selector === "string" ? page.locator(selector) : selector;
        await instance.click();
        await instance.fill(date);
        await instance.blur();
    };

    // 查找显示的 popover 弹窗
    const getPoperInstance = async (): Promise<Locator> => {
        await page.waitForTimeout(500);
        const elements = page.locator(".d-popover");
        const count = await elements.count();
        const visibleElements: (typeof elements)[] = [];

        for (let i = 0; i < count; i++) {
            const element = elements.nth(i);
            const style = await element.getAttribute("style");
            if (style && !style.includes("display: none")) {
                visibleElements.push(element);
            }
        }

        if (visibleElements.length > 0) {
            return visibleElements[visibleElements.length - 1];
        }

        throw new Error("未找到 popover 弹窗");
    };

    // 查找显示的 dialog 弹窗
    const getDialogInstance = async (): Promise<Locator> => {
        await page.waitForTimeout(1000);
        const elements = page.locator(".el-dialog");
        return elements.last();
    };

    // 自动化脚本
    // ----------------------------------------------------------------------------------

    // 等待登录成功
    try {
        await page.waitForSelector("#CreatorPlatform", { state: "visible" });
    } catch (error) {
        return { code: 414, message: "登录失效", data: page.url() };
    }

    // 跳转到发布页面
    await page.locator("#content-area .menu-container .publish-video .btn-wrapper .btn-inner").click();

    // 点击上传图文
    await page
        .locator('.header-tabs .creator-tab:not([style*="-9999px"])')
        .filter({ hasText: /^上传图文$/ })
        .click();

    // 获取待上传图片的本地路径
    const images = await Promise.all(
        params.banners.map((url) => {
            const fileName = getFilenameFromUrl(url);
            return downloadImage(url, path.join(tmpCachePath, fileName));
        }),
    );

    // 选择文件
    const fileChooser = await page.$("input.upload-input");
    if (fileChooser) await fileChooser.setInputFiles(images);

    // 填写标题
    const titleInstance = page.locator(".input input");
    await titleInstance.waitFor({ state: "visible", timeout: 1000 * 50 });
    await titleInstance.click();
    await titleInstance.fill(params.title);

    // 填写正文
    const descInstance = page.locator(".editor-container .tiptap.ProseMirror");
    await descInstance.click();
    await descInstance.pressSequentially(params.content.replace(/#.*?\[.*?]#/g, ""));

    // 填写话题
    if (params.topic && params.topic.length > 0) {
        for (const it of params.topic) {
            await descInstance.pressSequentially(`#${it.name}`);
            await page.locator("#creator-editor-topic-container").waitFor({ state: "visible" });
            await page.waitForTimeout(500);
            await page.locator("#creator-editor-topic-container .item").first().click();
        }
    }

    if (params.address) {
        // 填写地点
        await selectAddress(page.locator(".address-card-wrapper .d-select-wrapper"), params.address.name);
    }

    if (params.selfDeclaration) {
        // 自主声明
        await page.locator(".declaration-wrapper .d-select-wrapper").click();
        const poperInstance = await getPoperInstance();
        const selfDeclarationInstance = poperInstance.locator(".d-options .d-option");
        if (params.selfDeclaration.type === "fictional-rendition") {
            await selfDeclarationInstance.filter({ hasText: "虚构演绎，仅供娱乐" }).click();
        } else if (params.selfDeclaration.type === "ai-generated") {
            await selfDeclarationInstance.filter({ hasText: "笔记含AI合成内容" }).click();
        } else if (params.selfDeclaration.type === "source-statement") {
            await selfDeclarationInstance.filter({ hasText: /内容来源声明/ }).click();
            // 内容来源声明二级菜单
            const selfDeclarationSecondaryMenuInstance = (await getPoperInstance()).locator(".d-options .d-option");
            // 等待元素出现
            await selfDeclarationSecondaryMenuInstance.first().waitFor();
            if (params.selfDeclaration.childType === "self-labeling") {
                await selfDeclarationSecondaryMenuInstance.filter({ hasText: "已在正文中自主标注" }).click();
            } else if (params.selfDeclaration.childType === "self-shooting") {
                const { shootingDate, shootingLocation } = params.selfDeclaration;
                await selfDeclarationSecondaryMenuInstance.filter({ hasText: "自主拍摄" }).click();
                // 自主拍摄弹窗
                const selfShootingPopup = await getDialogInstance();
                const hasCustomContent = shootingDate || shootingLocation;

                // 选择拍摄地点
                if (shootingLocation) {
                    await selectAddress(selfShootingPopup.locator(".address-input"), shootingLocation.name);
                }
                // 选择拍摄日期
                if (shootingDate) {
                    await selectDate(selfShootingPopup.locator(".date-picker input"), shootingDate);
                }

                await selfShootingPopup
                    .locator("footer button")
                    .filter({ hasText: hasCustomContent ? "确认" : "取消" })
                    .click();
            } else if (params.selfDeclaration.childType === "transshipment") {
                await selfDeclarationSecondaryMenuInstance.filter({ hasText: "来源转载" }).click();
                // 来源媒体弹窗
                const selfShootingPopup = await getDialogInstance();

                const sourceMedia = params.selfDeclaration.sourceMedia;
                if (sourceMedia) {
                    await selfShootingPopup.locator(".el-input input").fill(sourceMedia);
                }

                await selfShootingPopup
                    .locator("footer button")
                    .filter({ hasText: sourceMedia ? "确认" : "取消" })
                    .click();
            }
        }
    }

    // 可见范围 - 仅自己可见
    if (params.visibleRange === "private") {
        await page.locator(".publish-page-content-setting-content .d-select-wrapper").last().click();
        const poperInstance = await getPoperInstance();
        await poperInstance.locator(".d-options .d-option").filter({ hasText: "仅自己可见" }).click();
    }

    task._timerRecord.PrePublish = Date.now();

    // 发布时间选择：立即发布 / 定时发布
    const releaseTimeInstance = page
        .locator("label")
        .filter({ hasText: params.isImmediatelyPublish ? "立即发布" : "定时发布" });
    await releaseTimeInstance.click();

    if (params.scheduledPublish) {
        // 自定义发布时间
        await selectDate(".date-picker input", params.scheduledPublish);
    }

    // 等待图片上传完成：检测 .progress-container 消失且发布按钮存在
    await page.waitForFunction(
        () => {
            const publishBtn = Array.from(document.querySelectorAll("button")).find(
                (b) => b.textContent?.trim() === "发布",
            );
            const uploading = document.querySelector(".progress-container");
            return !!publishBtn && !uploading;
        },
        { timeout: 180000, polling: 2000 },
    );

    const response = await new Promise<string>((resolve, reject) => {
        // 定义响应处理函数
        const handleResponse = async (response: Response) => {
            if (response.url().includes("/web_api/sns/v2/note")) {
                const jsonResponse = await response.json();
                page.off("response", handleResponse);
                if (jsonResponse?.success) {
                    resolve(jsonResponse?.data?.id);
                } else {
                    reject(new Error(jsonResponse?.msg || "发布失败"));
                }
            }
        };

        // 开始监听响应事件
        page.on("response", handleResponse);

        page.locator(".publish-page-publish-btn button").filter({ hasText: "发布" }).click();
    });

    await updateTaskState?.({
        state: TaskState.SUCCESS,
        result: {
            response,
        },
    });

    // 关闭页面
    await page.close();

    return success(response);
};
